// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bvWJE","content":"styles_content__2hdA-","tableWrap":"styles_tableWrap__2tvhI"};